import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    CRow, CCol, CCard, CCardHeader, CCardBody, CCardFooter, CLabel, CFormGroup,
    CButton, CTooltip,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { checkActions, housingActions, positionActions, projectActions, employeeActions, noteActions } from 'src/_actions';
import { helps } from 'src/_helpers';
import EmployeeTimekeeping from 'src/views/employees/EmployeeTimekeeping';
import EmployeeTimeKeepingExport from 'src/views/employees/EmployeeTimeKeepingExport';
import EmployeeCheckForm from 'src/views/employees/EmployeeCheckForm';
import DatePicker from 'react-datepicker';
import locale from 'date-fns/locale/vi';


class EmployeeTimekeepingContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            curent_date: new Date(),
            project_options: [],
            project_default_option: {},
            project_id: '',
            projects: [],
            filter_projects: [],
            month: new Date(),
            show_form: false,
        }
        this.handleChangeMonth = this.handleChangeMonth.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
    }

    componentDidMount() {
        this.getProjects().then((projects) => {
            var project_options = [];
            //console.log(projects);
            if (!helps.isEmpty(projects) && projects.length > 0) {
                projects.map((project) => {
                    project_options.push({
                        value: project.id,
                        label: project.name,
                    });
                });
                this.setState({ project_options: project_options, projects: projects, filter_projects: projects });
            }
        });
        this.getEmployees();
        this.getPositions();
        this.getHousings();
        this.getChecks({ curent_date: this.state.month });
    }

    async getChecks(params = {}) {
        const { employee } = this.props;
        params['employee'] = employee;
        let _checks = await this.props.getChecks(params, 10000);
        return _checks;
    }

    async getProjects() {
        const { projects } = this.props;
        if (helps.isEmpty(projects)) {
            let _projects = await this.props.getProjects();
            return _projects;
        } else {
            return projects;
        }
    }

    async getEmployees() {
        const { employees } = this.props;
        if (helps.isEmpty(employees)) {
            let _employees = await this.props.getEmployees();
            return _employees;
        }
    }

    async getPositions() {
        const { positions } = this.props;
        if (helps.isEmpty(positions)) {
            let _positions = await this.props.getPositions();
            return _positions;
        }
    }

    async getHousings() {
        const { housings } = this.props;
        if (helps.isEmpty(housings)) {
            let _housings = await this.props.getHousings();
            return _housings;
        }
    }

    handleChangeMonth(value) {
        this.setState({ month: value });
        this.getChecks({ curent_date: value });
    }

    async doAddcheck(check) {
        let _check = await this.doAdd(check);
        this.getChecks({ curent_date: check.added_time });
    }

    async doAdd(check) {
        return await this.props.add(check);
    }

    toggleForm() {
        this.setState({ show_form: !this.state.show_form })
    }

    render() {
        const { employee } = this.props;
        let today = new Date().toISOString().slice(0, 10);
        var date_val = today;
        if (this.state.curent_date) {
            date_val = helps.formatDate_for_input(this.state.curent_date.getTime(), 'YYYY-MM-DD');
        }
        return (
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol md={4} sm={12} className='mb-2'>
                            <div className='pt-1'>
                                Bảng Chấm Công: <b>{employee.fullname}</b> ({employee.employee_id})
                            </div>
                        </CCol>
                        <CCol md={4} sm={12} className='pb-2 pt-1 pl-2 text-right'>
                            <CTooltip content={'Checkin-Checkout cho nhân sự: ' + employee.fullname}>
                                <CButton type="button" size='sm' color={"warning"} onClick={(e) => this.setState({ show_form: !this.state.show_form })}>
                                    <CIcon name="cil-save" className="mfe-1 mt-0"></CIcon>
                                    Checkin - Checkout
                                </CButton>
                            </CTooltip>
                        </CCol>
                        <CCol md={4} sm={12} className='mb-2 text-right'>
                            <CFormGroup variant='custom-radio' inline>
                                <CLabel htmlFor="curent_date" className='mt-1'>tháng: </CLabel>
                                <DatePicker
                                    locale={locale}
                                    selected={this.state.month}
                                    onChange={(date) => { this.handleChangeMonth(date) }}
                                    dateFormat="MM/yyyy"
                                    showMonthYearPicker
                                    className='ml-2 form-control font-weight-bold'
                                />
                            </CFormGroup>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CCardBody>
                    <EmployeeTimekeeping
                        key={'list-' + this.state.month.toDateString()}
                        {... this.props}
                        user={this.props.user}
                        projects={this.state.filter_projects}
                        month={this.state.month}
                        employee={this.props.employee}
                    />
                    <EmployeeCheckForm
                        {... this.props}
                        employee={this.props.employee}
                        show_form={this.state.show_form}
                        user={this.props.user}
                        toggleForm={this.toggleForm}
                    />
                </CCardBody>
                <CCardFooter>
                    <CRow>
                        <CCol>
                            <EmployeeTimeKeepingExport {... this.props} month={this.state.month} employee={this.props.employee} />
                        </CCol>
                    </CRow>
                </CCardFooter>
            </CCard>
        );
    }
}

function mapStateToProps(state) {
    const { loading, checks } = state.checkReducer;
    const { projects } = state.projectReducer;
    const { employees } = state.employeeReducer;
    const { positions } = state.positionReducer;
    const { user } = state.authentication;
    const { housings } = state.housingReducer;
    return { loading, user, checks, projects, employees, positions, housings };
}

const actionCreators = {
    getChecks: checkActions.getAll,
    getProjects: projectActions.getAll,
    getEmployees: employeeActions.getAll,
    getPositions: positionActions.getAll,
    getHousings: housingActions.getAll,
    add: checkActions.add,
    _delete: checkActions._delete,
    add: checkActions.add,
    update: checkActions.update,
    addNote: noteActions.add,
};

const connectedContainer = connect(mapStateToProps, actionCreators)(EmployeeTimekeepingContainer);
export { connectedContainer as EmployeeTimekeepingContainer };